/** Type guard to check an event target is an element. Safe to use with child windows and portals. */
export function checkIsDomElement(
  node: EventTarget | null | undefined,
): node is Element {
  // Use a duck typing approach
  return (
    !!node &&
    "nodeType" in node &&
    node.nodeType === Node.ELEMENT_NODE &&
    "tagName" in node
  );
}

export function checkIsHtmlElement(
  node: EventTarget | null | undefined,
): node is HTMLElement {
  return checkIsDomElement(node) && "innerHTML" in node;
}
